import 'react-dropdown-tree-select/dist/styles.css'
import {useState} from "react";
import {twMerge} from "tailwind-merge";
import {DropdownTreeSelectHoc} from "../../hoc";

const DropdownTree = ({data = [], label = "", unselectAllHandler, classes = {}, ...otherProps}) => {

    const {inputClasses = ""} = classes;
    const [showDropDown, setShowDropDown] = useState(false);

    return (
        <div className="relative w-full">
            <div
                className={`w-screen h-screen fixed left-0 top-0 z-20 ${showDropDown ? "" : "hidden"}`}
                onClick={() => setShowDropDown(false)}/>

            <button
                onClick={() => setShowDropDown(true)}
                type="button"
                className={twMerge("w-full rounded-[0.875rem] bg-pol-light-3 px-3.5 py-2.5 border border-pol-light-4 flex items-center justify-between text-pol-gray", inputClasses)}>
                <p className="font-semibold">{label}</p>
                <i className="icon-left-arrow block text-sm mb-1" />
            </button>

            <div
                className={`absolute z-20 w-full h-[18.125rem] bg-white rounded-2xl top-0 left-0 shadow-[0_0_9px_11px_rgba(142,130,180,0.06)] overflow-y-auto pol-scroll px-3.5 pt-3 pb-0 ${showDropDown ? "" : "hidden"}`}>
                <DropdownTreeSelectHoc
                    texts={{
                        placeholder: "جستجو...",
                        noMatches: "موردی پیدا نشد"
                    }}
                    showDropdown="always"
                    className="pol-dropdown-tree"
                    data={data}
                    {...otherProps} />

                {/*<div*/}
                {/*    className="bg-white w-full h-9 sticky top-[calc(100%-36px)] left-0 flex-center z-10 font-semibold text-pol-red">*/}
                {/*    <button type="button" className="flex items-center" onClick={unselectAllHandler}>*/}
                {/*        <i className="icon-trash ml-2.5"/>*/}
                {/*        <span className="">حذف فیلتر</span>*/}
                {/*    </button>*/}
                {/*</div>*/}
            </div>
        </div>
    )
}

export default DropdownTree;
